﻿import React, { useState, useEffect } from 'react';
import { ResponseError } from '../../models/response-error';
import { ModalMetadata } from '../../models/modal-metadata';
import { MessageBoxReply } from '../../models/message-box-reply';
import { ModalMessageType, MessageBoxReplyType } from '../../models/enums';

import { Popup as DialogPopup } from 'devextreme-react/popup';
import { Button } from 'devextreme-react/button';
import Toast from 'devextreme-react/toast';

export interface Props {
    metadata: ModalMetadata;
    onReply?: (reply: MessageBoxReply) => void;
    onClose?: () => void;
}

export default function GlobalDialog(props: Props) {
    const [dialogVisible, setDialogVisible] =
        useState<boolean>(true);

    const [responseError, setResponseError] =
        useState<ResponseError>();

    const [bodyMessage, setBodyMessage] =
        useState<string>();

    const [toastVisible, setToastVisible] =
        useState<boolean>();

    const [toastMessage, setToastMessage] =
        useState<string>();

    const [toastType, setToastType] =
        useState<any>();

    const [reply, setReply] =
        useState<MessageBoxReply>();

    useEffect(() => {
        //parseError();
        parseMetadata();
    }, [props.metadata]);

    const titleIcon = () => {
        switch (props.metadata.mode) {
            case ModalMessageType.Information:
                return <div><span className="material-symbols-outlined pw-blue">info</span></div>
            case ModalMessageType.Warning:
                return <div><span className="material-symbols-outlined pw-orange">warning</span></div>
            case ModalMessageType.Error:
                return <div><span className="material-symbols-outlined pw-red">error</span></div>
            case ModalMessageType.PromptOk:
                return <div><span className="material-symbols-outlined pw-blue">help</span></div>
            case ModalMessageType.PromptYesNo:
                return <div><span className="material-symbols-outlined pw-blue">help</span></div>
            case ModalMessageType.PromptMessage:
                return <div><span className="material-symbols-outlined pw-blue">contact_support</span></div>
            default:
                return <div><span className="material-symbols-outlined pw-blue">info</span></div>
        }
    }

    return (
        <div>
            {dialogVisible &&
                <DialogPopup
                    visible={dialogVisible}
                    onHiding={hideDialog}
                    width={props.metadata && props.metadata.width ?
                        props.metadata.width : "80vw"}
                    height={props.metadata && props.metadata.height ?
                        props.metadata.height : ( dialogVisible ? "89vh" : "0" ) }
                    animation={undefined}
                    dragEnabled={true}
                    showTitle={false}
                    fullScreen={false}
                    hideOnOutsideClick={false}
                    wrapperAttr={{ class: "global-dialog-popup" }}
                    title={props.metadata && props.metadata.title ? props.metadata.title : "Message"}>
                    {/* ! The dialog needs to be reduced to 0 height when "hidden," otherwise its parent blocks
                           all mouse actions inside its boundaries */}

                    <div className="global-dialog-box">
                        {props.metadata && props.metadata.title &&
                            <div className="pw-comp-row border-bottom pw-margin-bottom-05">
                                <div>{titleIcon()}</div>
                                <div className="pw-margin-left-1">{props.metadata.title}</div>
                            </div>
                        }

                        {responseError &&
                            <div className="global-dialog-body-container">
                                <div className="global-dialog-body">
                                    {responseError.message}
                                </div>
                            </div>
                        }

                        {bodyMessage &&
                            <div className="global-dialog-body-container">
                                <div className="global-dialog-body">
                                    {bodyMessage}
                                </div>
                            </div>
                        }

                        <div className="flex justify-center mt-4">
                            <div className="pw-comp-row">
                                <div className="pw-centered-buttons-container">
                                    {props.metadata.mode === ModalMessageType.PromptMessage &&
                                        <div> Not yet implemented </div>
                                    }

                                    <div>
                                        {(props.metadata.mode === ModalMessageType.Information
                                            || props.metadata.mode === ModalMessageType.Warning
                                            || props.metadata.mode === ModalMessageType.Error)
                                            &&
                                            <Button text="Close" className=""
                                                onClick={onClose} />
                                        }
                                        {responseError && responseError.details &&
                                            <Button className="pw-margin-left-05" text="Details..." onClick={onCopyDetails} />
                                        }
                                    </div>

                                    {props.metadata.mode === ModalMessageType.PromptOk &&
                                        <div>
                                            <Button text="OK" className=""
                                                onClick={onOk} />
                                        </div>
                                    }

                                    {props.metadata.mode === ModalMessageType.PromptYesNo &&
                                        <div>
                                            <div className="save-toolbar pw-margin-right-05">
                                                <Button id="yesButton" text="Yes" icon="check" type="success"
                                                    className="pw-button"
                                                    hint="choose yes"
                                                    height='1.8rem'
                                                    onClick={onYes} />

                                                <Button id="noButton" text="No" icon="close" type="normal"
                                                    className="pw-button"
                                                    hint="choose no"
                                                    height='1.8rem'
                                                    onClick={onNo} />
                                            </div>
                                        </div>
                                    }

                                    {props.metadata.mode === ModalMessageType.PromptMessage &&
                                        <div className="save-toolbar pw-margin-right-05">
                                            <Button id="submitButton" text="Submit" icon="check" type="success"
                                                className="pw-button"
                                                hint="submit"
                                                height='1.8rem'
                                                onClick={onSubmit} />

                                            <Button id="cancelButton" text="Cancel" icon="close" type="normal"
                                                className="pw-button"
                                                hint="cancel"
                                                height='1.8rem'
                                                onClick={onCancel} />
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*
                    <div>{responseError && responseError.message ? responseError.message : "Unexpected error occurred"}</div>
                    */}

                </DialogPopup>
            }

            <Toast visible={toastVisible}
                message={toastMessage}
                type={toastType}
                onHiding={onToastHiding}
                displayTime={3000} />

        </div>
    );

    function onCopyDetails() {
        if (responseError && responseError.details)
            navigator.clipboard.writeText(responseError.details);

        setToastMessage("Details have been copied to the clipboard");
        setToastType("success");
        setToastVisible(true);
    }

    function hideDialog() {
        setDialogVisible(false);
    }

    async function parseMetadata() {

        if (props.metadata.error)
            parseError();
        else
            parseMessage();
    }

    async function parseMessage() {
        console.log("IN parseMessage()");
        console.log(props.metadata);

        setBodyMessage(props.metadata.message);
    }

    async function parseError() {
        console.log("IN parseError()");
        console.log(props.metadata);

        try {
            const error = await props.metadata.error.json() as ResponseError;

            console.log("PARSED error--");
            console.log(error);

            if (error)
                setResponseError(error);

            else //- try to parse a plain JS error
                console.log("DIDN'T PARSE");

        } catch (e) {
            //todo

            console.log("Error parsing failed...");
        }
    }

    function onOk() {
        const reply: MessageBoxReply = {
            reply: MessageBoxReplyType.Ok,
            code: props.metadata.code
        }

        onReply(reply);
    }

    function onCancel() {
        const reply: MessageBoxReply = {
            reply: MessageBoxReplyType.Cancel,
            code: props.metadata.code
        }

        onReply(reply);
    }

    function onYes() {
        const reply: MessageBoxReply = {
            reply: MessageBoxReplyType.Yes,
            code: props.metadata.code
        }

        onReply(reply);
    }

    function onNo() {
        const reply: MessageBoxReply = {
            reply: MessageBoxReplyType.No,
            code: props.metadata.code
        }

        onReply(reply);
    }

    function onSubmit() {

        //todo


    }

    function onReply(reply: MessageBoxReply) {
        if (props.onReply)
            props.onReply(reply);
    }

    function onClose() {
        setDialogVisible(false);

        if (props.onClose)
            props.onClose();
    }

    function onToastHiding() {
        setToastVisible(false);
        setToastMessage(undefined);
        setToastType(undefined);
    }

    function showToast(message: string, toastType: string) {
        setToastMessage(message);
        setToastType(toastType);
        setToastVisible(true);
    }

}